import { PaymentTypesList } from '../components/PaymentTypesList';

export const PaymentTypesPage = () => {
  return <PaymentTypesList />;
};
